import { ref } from 'vue'
import firebase from '../../firebase'
import { updateDoc, doc, deleteField, deleteDoc } from 'firebase/firestore'

const removeDeviceFromUser = () => {
  const removing = ref(false)
  const removeDevice = async (deviceId) => {
    removing.value = true
    const docRef = doc(
      firebase.db,
      'users',
      firebase.firebaseAuth.currentUser.uid
    )
    const mapKey = 'devices.' + deviceId
    await updateDoc(docRef, {
      [mapKey]: deleteField()
    })
    removing.value = false
    // await deleteDoc(doc(db, "cities", "DC"));
  }
  return { removeDevice, removing }
}
export default removeDeviceFromUser
